export default __webpack_public_path__ + "static/media/eth.c8926f9e.svg";